import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { USER_NOT_SIGNED_IN_ERROR_MSG } from 'utils/constants/errors';
import { WORKOUTS, LOGS, DETAILS } from 'utils/constants/collectionNames';
import { WORKOUT, TYPE, SUBTYPE } from 'utils/constants/logs';
import {
  GET_WORKOUT_SUCCEED,
  GET_WORKOUT_ERROR,
  LOADING_STATE,
  CREATE_WORKOUT_LOG_SUCCEED,
  CREATE_WORKOUT_LOG_ERROR,
  GET_WORKOUT_LAST_LOG_SUCCESS,
  GET_WORKOUT_LAST_LOG_ERROR,
  GET_WORKOUT_LOG_SUCCESS,
  GET_WORKOUT_LOG_ERROR,
  LOADING_LAST_LOGGED_WORKOUT
} from './types';

export const getWorkout = (workoutId, history) => async dispatch => {
  let firestore = firebase.firestore();
  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      dispatch({
        type: LOADING_STATE
      });
      let docRef = firestore.collection(WORKOUTS).doc(workoutId);
      docRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            getSeries({ ...doc.data(), id: doc.id }, dispatch);
          } else {
            history.replace('/event-not-found');
          }
        })
        .catch(function(error) {
          console.log(error);
          dispatch({
            type: GET_WORKOUT_ERROR,
            payload: `error: ${error}`
          });
        });
    } else {
      throw new Error(USER_NOT_SIGNED_IN_ERROR_MSG);
    }
  });
};

const getSeries = (workout, dispatch) => {
  let firestore = firebase.firestore();
  firestore
    .collection(`workouts/${workout.id}/workout_series`)
    .orderBy('name', 'asc')
    .get()
    .then(querySnapshot => {
      const series =
        querySnapshot.docs &&
        querySnapshot.docs.map(seriesDoc => {
          return { ...seriesDoc.data(), id: seriesDoc.id };
        });
      if(series.length){
        series.sort((series1, series2) => {
          return (
            (series1.name > series2.name ? 1 : -1)
          );
        });
        getWorkoutSeriesExercises({ ...workout, series: series }, dispatch);
      }else {
        dispatch({
          type: GET_WORKOUT_SUCCEED,
          payload: {...workout, series: series}
        });
      }

    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_WORKOUT_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const getWorkoutSeriesExercises = (workout, dispatch) => {
  let firestore = firebase.firestore();
  let series = [...workout.series];
  series.map((seriesElement, index) => {
    return firestore
    .collection(`workouts/${workout.id}/workout_series/${seriesElement.id}/workout_exercises`)
    .get()
    .then(querySnapshot => {
      let exercies = querySnapshot.docs &&
        querySnapshot.docs.map(exerciseDoc => {
          return { ...exerciseDoc.data(), id: exerciseDoc.id };
        });
      series[index] = {...series[index], exerciseCollection: exercies}
      if(index+1 === series.length){
        dispatch({
          type: GET_WORKOUT_SUCCEED,
          payload: {...workout, series: series}
        });
      }
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_WORKOUT_ERROR,
        payload: `error: ${error}`
      });
    });
  });
}

export const createWorkoutLog = (formValues, workout, loggedSeriesIndices, clientId) => async dispatch => {
  try {
    dispatch({
      type: LOADING_STATE
    });
    let firestore = firebase.firestore();
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        if(loggedSeriesIndices.length){
          let workoutLogObj = prepareWorkoutLogObj(user, workout, formValues, loggedSeriesIndices);
          firestore
            .collection(LOGS)
            .doc(clientId)
            .set({}, {merge: true})
            .then(() => {
              firestore
                .collection(LOGS)
                .doc(clientId)
                .collection(DETAILS)
                .add({ ...workoutLogObj })
                .then(function(docRef) {
                  dispatch({
                    type: CREATE_WORKOUT_LOG_SUCCEED
                  });
                })
                .catch(function(error) {
                  console.error('Error adding document: ', error);
                  dispatch({
                    type: CREATE_WORKOUT_LOG_ERROR,
                    payload: `error: ${error}`
                  });
                });
            })
            .catch(function(error) {
              console.error('Error adding document: ', error);
              dispatch({
                type: CREATE_WORKOUT_LOG_ERROR,
                payload: `error: ${error}`
              });
            });
        }
      } else {
        throw new Error(USER_NOT_SIGNED_IN_ERROR_MSG);
      }
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: CREATE_WORKOUT_LOG_ERROR,
      payload: `error: ${err}`
    });
  }
}

const prepareWorkoutLogObj = (trainer, workout, values, loggedSeriesIndices) => {
  return {
    type: "workout",
    subtype: "workout",
    description: "workout",
    date: new Date(),
    trainer_id: trainer.uid ,
    created_at: new Date(),
    is_once_a_day: false,
    workout_id: workout.id,
    name: workout.name,
    phase: `${workout.phase}`,
    level: workout.level,
    creator_type: "trainer",
    series: loggedSeriesIndices.map(index => {
      let seriesElement = values.series[index];
      return {
        series_id: seriesElement.id,
        series_name: seriesElement.name,
        original_reps: seriesElement.reps,
        original_method: seriesElement.method,
        original_sets: seriesElement.setsNum,
        sets: seriesElement.sets.map(set => {
          return {
            exercises: seriesElement.exercises.map(exercise => {
              return {
                exercise_id: exercise.id,
                exercise_name: exercise.name,
                tempo: exercise.tempo,
                rest: exercise.rest,
                rest_unit: exercise.rest_unit,
                is_rep: seriesElement.is_custom_reps,
                reps: set[`${exercise.id}`].reps,
                weight: set[`${exercise.id}`].weight
              }
            })
          }
        })
      }
    })
  }
}

export const getLastLoggedWorkout = clientId => async dispatch => {
  dispatch({ type: LOADING_LAST_LOGGED_WORKOUT });
  const firestore = firebase.firestore();
  const queryRef = firestore
    .collection(LOGS)
    .doc(clientId)
    .collection(DETAILS)
    .where(TYPE, '==', WORKOUT)
    .where(SUBTYPE, '==', WORKOUT)
    .orderBy("created_at", "desc")
    .limit(1)

  queryRef
    .get()
    .then(snapshot => {
      let workoutLastLog = [];
      snapshot.forEach(doc => {
        workoutLastLog.push({ ...doc.data(), id: doc.id });
      });

      dispatch({
        type: GET_WORKOUT_LAST_LOG_SUCCESS,
        payload: snapshot.empty? {} : { ...workoutLastLog[0] }
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_WORKOUT_LAST_LOG_ERROR,
        payload: `error: ${error}`
      });
    });
}

export const getWorkoutLog = (logId, clientId, history) => async dispatch => {
  dispatch({ type: LOADING_STATE });
  const firestore = firebase.firestore();
  const queryRef = firestore
    .collection(LOGS)
    .doc(clientId)
    .collection(DETAILS)
    .doc(logId)

  queryRef
    .get()
    .then(doc => {
      if (doc.exists) {
        let workoutLog = { ...doc.data() };
        workoutLog.series = workoutLog.series.sort((series1, series2) => {
          return (
            (series1.series_name > series2.series_name ? 1 : -1)
          );
        });
        dispatch({
          type: GET_WORKOUT_LOG_SUCCESS,
          payload: { ...workoutLog, workout_id: doc.data().id, id: doc.id }
        });
      } else {
        history.replace('/event-not-found');
      }
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_WORKOUT_LOG_ERROR,
        payload: `error: ${error}`
      });
    });
};